// retreive error object from store
export const errorStatus = (state) => state.error;
